import React, { useEffect, useState } from 'react';
import {
  Avatar, Divider, Drawer, Input, Spin,
} from 'antd';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Box, Text } from '../../shared/components';
import Flex from '../../shared/components/basic/Flex';

function getInitials(name) {
  const matches = name.match(/\b(\w)/g);
  let acronym;
  if (matches) { acronym = matches[0] + matches[1]; }
  return acronym;
}
export default function UsuariosDrawer(props) {
  const [limit, setLimitState] = useState(11);
  const [searchValue, setSearchValue] = useState(null);
  const [page, setPageState] = useState(0);
  const [loading, setLoadingstate] = useState(true);
  const [usuariosFilter, setUsuariosFilter] = useState([]);

  const {
    visible, onClose, usuarios, onSeleccionado, title, fetchData, total, pagination, width,
  } = props;
  useEffect(() => {
    if (!usuarios || usuarios.length === 0) {
      fetchData({ page, limit });
    }
  }, []);

  useEffect(() => {
    setUsuariosFilter(usuarios);
  }, usuarios)
  const nextPage = () => {
    const newPage = page + 1;
    setPageState(newPage);
    fetchData({
      page: newPage, limit, value: searchValue, incremental: pagination,
    });
  };
  const handleSearch = ({target: {value}}) => {
    // setSearchValue(value);
    // setPageState(0);
    // fetchData({ page: 0, limit, value });
    // console.log(value);
    setUsuariosFilter(usuarios.filter(usuario => 
      usuario.nombreCompleto?.toLowerCase().includes(value?.toLowerCase())
    ))
  };

  const optionsAtendidoPor = usuariosFilter.map((usuario) => {
    const {
      id, nombreCompleto, imgSrc, perfil,
    } = usuario;
    return (
      <>
        <Box key={id} style={{ cursor: 'pointer' }} className="hoverable" onClick={() => onSeleccionado(usuario)}>
          <Flex alignItems="center" className="hoverableColor" p="16px">
            <Avatar className="avatar" src={`${imgSrc || ''}`} size={64} style={{ minWidth: '64px' }}>
              {imgSrc ? '' : getInitials(nombreCompleto)}
            </Avatar>
            <Box ml="16px">
              <Box><Text color="#8C8C8C" fontSize="14px" mb="12px">{perfil}</Text></Box>
              <Box><Text fontSize="16px">{nombreCompleto}</Text></Box>
            </Box>
          </Flex>
          <Divider style={{ margin: '0px' }} />
        </Box>
      </>
    );
  });
  optionsAtendidoPor.unshift(
    <Box height="65px" />,
  );
  optionsAtendidoPor.unshift(
    <Box width={`${width - 17}px`} style={{ position: 'absolute', top: '67px', zIndex: 100 }} bg="white">
      <Divider style={{ margin: 0 }} />
      <Flex py="16px" px="16px">
        <Input.Search
          placeholder="Buscar..."
          onChange={value => handleSearch(value)}
          size="large"
        />
      </Flex>
      <Divider style={{ margin: 0 }} />

    </Box>,
  );
  const drawerContent = pagination ? (
    <Box>
      {!loading
      && (
        <InfiniteScroll
          scrollableTarget="usuariosDrawerWrapper"
          dataLength={optionsAtendidoPor.length} // This is important field to render the next data
          next={() => {
            nextPage();
          }}
          hasMore={total > optionsAtendidoPor.length}
          loader={<Flex mt="16px" justifyContent="center"><Spin /></Flex>}
          endMessage={null}
          // below props only if you need pull down functionality
          refreshFunction={() => {
          }}

        >
          {optionsAtendidoPor}
        </InfiniteScroll>
      )
      }
    </Box>
  ) : optionsAtendidoPor;

  return (
    <>
      <style>{`.infinite-scroll-component{ overflow-x:hidden !important;} .ant-drawer-close{position: fixed; margin-right: 16px; height:67px; z-index:100;} .ant-drawer-title{ position:fixed; background-color:white; width:${width - 17}px; margin-top: -24px; height:67px; z-index:100;} .ant-drawer-header{ padding: 24px 0 0 0; height:67px;} .ant-drawer-body{ padding: 0 0 24px 0;} .hoverable:hover .hoverableColor{background-color:#fafafa; }`}</style>
      <Drawer
        title={(
          <Box width="67px" bg="white" pt="24px">
            <Text mx="16px" mb="20px" fontSize="20px" fontWeight="semibold">{title}</Text>
          </Box>
)}
        placement="right"
        onClose={() => onClose()}
        visible={visible}
        width={width}
        afterVisibleChange={() => {
          if (document.getElementsByClassName('ant-drawer-wrapper-body').length !== 0) {
            document.getElementsByClassName('ant-drawer-wrapper-body')[0].id = 'usuariosDrawerWrapper';
            setLoadingstate(false);
          }
        }}
      >
        {drawerContent}
      </Drawer>
    </>
  );
}
UsuariosDrawer.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSeleccionado: PropTypes.func.isRequired,
  fetchData: PropTypes.func,
  usuarios: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number.isRequired, nombreCompleto: PropTypes.string.isRequired, imgSrc: PropTypes.string })).isRequired,
  title: PropTypes.string,
  total: PropTypes.number,
  width: PropTypes.number,
  pagination: PropTypes.bool,
};

UsuariosDrawer.defaultProps = {
  title: 'Usuarios',
  total: -1,
  fetchData: (page, limit) => {},
  pagination: false,
  width: 480,
};
